import React from "react";
import { observer } from "mobx-react";
import { PaymentReceiptUpdateStore } from "../../store";
import { PaymentReceiptUpdateForm } from "./PaymentReceiptUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type PaymentReceiptUpdateProps = {
  paymentReceiptUpdateStore: PaymentReceiptUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const PaymentReceiptUpdate: React.FC<PaymentReceiptUpdateProps> =
  observer(
    ({ paymentReceiptUpdateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={paymentReceiptUpdateStore.isSaving} />
          <OutdatedAfterSaveNotice
            open={paymentReceiptUpdateStore.savedButOutdated}
            onReload={() => paymentReceiptUpdateStore.reloadPaymentReceipt()}
            reloadDisabled={paymentReceiptUpdateStore.isProcessing}
          />
          <PaymentReceiptUpdateForm
            paymentReceiptUpdateStore={paymentReceiptUpdateStore}
            paymentReceiptOnRestoreFile={(id: string) =>
              paymentReceiptUpdateStore.paymentReceiptRestoreFile(id)
            }
            paymentReceiptOnLoadFile={(file: any) =>
              paymentReceiptUpdateStore.paymentReceiptUploadFile(file)
            }
            paymentReceiptOnCommitFile={(changes) =>
              paymentReceiptUpdateStore.paymentReceiptCommitFile(changes)
            }
            paymentReceiptFiles={
              paymentReceiptUpdateStore.entityValues.__paymentReceipt_files
            }
            paymentReceiptError={
              paymentReceiptUpdateStore.errors.paymentReceipt?.message
            }
            typeError={paymentReceiptUpdateStore.errors.type?.message}
            typeSelectedValue={paymentReceiptUpdateStore.entityValues.showType}
            amountError={paymentReceiptUpdateStore.errors.amount?.message}
            amount={paymentReceiptUpdateStore.entityValues.amount}
            issueDateTimeError={
              paymentReceiptUpdateStore.errors.issueDateTime?.message
            }
            onIssueDateTimeChange={(value) => {
              paymentReceiptUpdateStore.setIssueDateTimeValue(value);
            }}
            issueDateTime={paymentReceiptUpdateStore.entityValues.issueDateTime}
            totalUsesError={paymentReceiptUpdateStore.errors.totalUses?.message}
            totalUses={paymentReceiptUpdateStore.entityValues.totalUses}
            remainingUsesError={
              paymentReceiptUpdateStore.errors.remainingUses?.message
            }
            remainingUses={paymentReceiptUpdateStore.entityValues.remainingUses}
            usesVisibleColumns={paymentReceiptUpdateStore.usesVisibleColumns}
            usesRows={paymentReceiptUpdateStore.entityValues.showUses}
            dummyCRUDRestoredObservable={
              paymentReceiptUpdateStore.dummyCRUDRestoredObservable
            }
            recordId={
              paymentReceiptUpdateStore.paymentReceiptInstance?.id || ""
            }
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={paymentReceiptUpdateStore.saveDisabled}
            onSave={() => paymentReceiptUpdateStore.savePaymentReceipt()}
            onCancel={() => paymentReceiptUpdateStore.cancelPaymentReceipt()}
          />
          <ErrorDialog
            open={paymentReceiptUpdateStore.errorDialogOpened}
            title={paymentReceiptUpdateStore.errorTitle}
            description={paymentReceiptUpdateStore.errorDescription}
            onClose={() => paymentReceiptUpdateStore.closeErrorDialog()}
          />
          <ConfirmCancelDialog
            open={paymentReceiptUpdateStore.confirmDialogOpened}
            title={paymentReceiptUpdateStore.confirmDialogTitle}
            description={paymentReceiptUpdateStore.confirmDialogDescription}
            onConfirm={() => paymentReceiptUpdateStore.executeConfirmedAction()}
            onCancel={() => paymentReceiptUpdateStore.closeConfirmDialog()}
          />
        </>
      );
    }
  );
